import {Component} from 'react';
import myAjax from '../global/libs/myAjax.js';
import {getTokenAjax, myAjaxSync} from '../global/libs/myAjax.js';
import {DESIGN} from '../global/libs/CONFIG.js';
import CONFIG from '../global/libs/CONFIG.js';
import ShareNavbar from './ShareNavbar.js';
import newlineToBr from '../global/libs/newlineToBr.js';
import UserRatingButton from './UserRatingButton.js';
import {USER_INFO, authenticate} from '../global/libs/authUtil.js';
import Unauthorized from './Unauthorized.js';
import {get_cookie, save_cookie} from '../global/libs/cookie.js';
import queryString from 'query-string';
import PropTypes from 'prop-types';
import {useParams} from 'react-router-dom';
import './Common.css';
import './ShareQA.css';
import setAspectRatioToImg from '../global/libs/setAspectRatioToImg.js';

class ShareQAComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inner_category: '',
      questionLines: '',
      answerLines: '',
      answerLines2: '',
      initial: false,
      authorized: false,
      authorization_faild: false,
      prepared: false,
      logId: -1,
      error: '',
      isPreview: false
    };

    this.setRatingSettings = this.setRatingSettings.bind(this);
    this.getAnswer = this.getAnswer.bind(this);

    if (!CONFIG.DISABLE_JWT) {
      getTokenAjax('/get_token/'); // トークン取得API
    }
  }

  componentDidMount() {
    let query = queryString.parse(window.location.search);
    let isPreview = false;
    if (CONFIG.REQURE_SOCIAL_LOGIN && !this.state.authorized) {
      this.waitForLogin();
      if (query.behavior_mode_key) {
        isPreview = this.checkAES(query.behavior_mode_key);
        this.setState({isPreview: isPreview});
      }
    } else {
      if (query.behavior_mode_key) {
        isPreview = this.checkAES(query.behavior_mode_key);
        this.setState({isPreview: isPreview});
      }
      this.setState({authorized: true});
      this.setRatingSettings();
      this.getAnswer(isPreview);
    }
  }

  componentDidUpdate() {
    if (CONFIG.REQURE_SOCIAL_LOGIN && !this.state.authorized) {
      /* NOP */
    } else {
      if (!this.state.authorized && !this.state.prepared) {
        if (this.state.error.length > 0) console.error(this.state.error);
      } else if (!this.state.prepared) {
        let query = queryString.parse(window.location.search);
        let isPreview = false;
        if (query.behavior_mode_key) {
          isPreview = this.checkAES(query.behavior_mode_key);
          this.setState({isPreview: isPreview});
        }
        this.setRatingSettings();
        this.getAnswer(isPreview);
      }
    }

    if (this.AnswerTr) {
      setAspectRatioToImg(this.AnswerTr);
    }
    if (this.AnswerTr2) {
      setAspectRatioToImg(this.AnswerTr2);
    }
  }

  waitForLogin() {
    var self = this;
    var initialized = function () {
      self.setState({initial: false});
    };
    authenticate(initialized)
      .done(() => {
        this.setState({authorized: true});
      })
      .fail(() => {
        this.setState({authorization_faild: true});
      });
  }

  setRatingSettings() {
    const pnameEnableUserRating = 'enable_user_rating';
    const pnameRatingAnswerRequired = 'user_rating_required';
    const pnameEnableRatingReason = 'enable_negative_user_rating_reason';
    const pnameRatingReasonMsg = 'msg_ask_why_negative_rating';
    const pnameRatingReasonsPrefix = 'negative_user_rating_reason_answer_';

    myAjax('/api/operation/setting_list/', '', 'GET', false, true)
      .done(
        function (data) {
          function getSiteCustomizeData(dictData) {
            if (typeof dictData === 'undefined') {
              return '';
            }
            return dictData.value;
          }
          let enableUserRating = getSiteCustomizeData(data.find((item) => item.name === pnameEnableUserRating));
          let enableRatingReason = getSiteCustomizeData(data.find((item) => item.name === pnameEnableRatingReason));
          let ratingAnswerRequired = getSiteCustomizeData(data.find((item) => item.name === pnameRatingAnswerRequired));
          let ratingReasonMsg = getSiteCustomizeData(data.find((item) => item.name === pnameRatingReasonMsg));

          let ratingReasons = data.filter((item) => item.name.indexOf(pnameRatingReasonsPrefix) === 0);

          this.setState({
            enableUserRating: enableUserRating,
            ratingAnswerRequired: ratingAnswerRequired,
            enableRatingReason: enableRatingReason,
            ratingReasonMsg: ratingReasonMsg,
            ratingReasons: ratingReasons
          });
        }.bind(this)
      )
      .fail((data) => {
        if (data.status === 404) {
          // 認証は完了しているが、データが見つからない
          this.setState({
            dept_specific_fail: true,
            authorized: true,
            authorization_failed: false,
            prepared: true
          });
        } else {
          // 認証失敗
          this.setState({
            authorized: false,
            authorization_failed: true,
            prepared: false
          });
        }
      });
  }

  isNumber(value) {
    return !Number.isNaN(parseInt(value));
  }

  checkAES(aes) {
    if (!aes) return false;
    let result = myAjaxSync('/api/operation/aes_decode/', {aes: aes});
    if (result.status !== 200) {
      console.log('aes check failed.');
      return false;
    }
    if (!result.responseJSON.decoded) return false;
    let decoded = JSON.parse(result.responseJSON.decoded);
    const isIdMatch = this.props.params.id === String(decoded.qa_id);
    return isIdMatch;
  }

  getAnswer(isPreview) {
    save_cookie();
    let resultCategory = '';
    let answer_overview = '';
    let answer_detail = '';
    let resultQuestion = '';
    let qaId = this.props.params.id;
    let qa_datetime = '';
    let dept_specific_fail = false;
    const storage = window.sessionStorage;

    const prevShareQaId = storage.getItem('shareqa_qaid') ? storage.getItem('shareqa_qaid') : '-1';
    if (prevShareQaId !== qaId) {
      storage.removeItem('shareqa_logid');
      console.log('deleted previous log id.');
      storage.removeItem('shareqa_access_time');
    }
    const accessTime = Date.now();
    const beforeAccessTime = storage.getItem('shareqa_access_time')
      ? Number(storage.getItem('shareqa_access_time'))
      : 0;
    const isNewAccess = accessTime - beforeAccessTime > 60000;
    storage.setItem('shareqa_access_time', accessTime);
    if (isNewAccess) {
      storage.removeItem('shareqa_qaid');
      storage.removeItem('shareqa_logid');
    }
    console.log(storage.getItem('shareqa_logid'));
    const logId = isPreview ? 'preview' : storage.getItem('shareqa_logid');
    const logIdQuery = logId ? '?logid=' + logId : '';
    const webClientId = get_cookie()['WEB_CLIENT_ID'];
    const userId = !USER_INFO || !USER_INFO['uid'] ? webClientId : USER_INFO['uid'];
    const userIdQuery = logIdQuery.length > 0 ? '&uid=' + userId : '?uid=' + userId;

    myAjax('/api/qa_data' + CONFIG.SHARE_URL + qaId + logIdQuery + userIdQuery, '', 'GET', false, true)
      .done((data) => {
        resultCategory = '＜' + data.category + '＞';
        resultQuestion = data.question;
        answer_overview = data.brief_answer;
        answer_detail = data.answer;
        qa_datetime = data.shared_qa_date !== undefined ? data.shared_qa_date.slice(0, 10) : '';
        if (data.dept_specific_fail && data.dept_specific_fail === true) {
          dept_specific_fail = true;
        }
        const logId = this.isNumber(data.log_id) ? Number(data.log_id) : -1;
        storage.setItem('shareqa_qaid', qaId);
        if (logId > 0) storage.setItem('shareqa_logid', logId);
        else storage.removeItem('shareqa_logid');

        this.setState({
          dept_specific_fail: dept_specific_fail,
          inner_category: resultCategory,
          questionLines: resultQuestion,
          answerLines: answer_overview,
          answerLines2: answer_detail,
          datetime: qa_datetime,
          authorized: true,
          authorization_failed: false,
          prepared: true,
          logId: logId
        });
      })
      .fail((data) => {
        if (data.status === 404) {
          // 認証は完了しているが、データが見つからない
          this.setState({
            dept_specific_fail: true,
            authorized: true,
            authorization_failed: false,
            prepared: true
          });
        } else {
          // 認証失敗
          console.error(data.responseText);
          this.setState({
            authorized: false,
            authorization_failed: true,
            prepared: false,
            error: data.responseText
          });
        }
      });
  }

  render() {
    if (this.state.dept_specific_fail) {
      return (
        <div className="container">
          <ShareNavbar />
          <table
            className="table"
            style={{
              fontSize: 'medium',
              wordBreak: 'break-all',
              marginTop: '10px'
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    paddingTop: '15px',
                    paddingBottom: '0px',
                    width: '150px'
                  }}
                >
                  {DESIGN.SORRY}
                </td>
                <td
                  style={{
                    paddingTop: '15px',
                    paddingBottom: '0px',
                    verticalAlign: 'middle'
                  }}
                >
                  {CONFIG.NO_SHARE_QA_MESSAGE_IN_DEPT_SPECIFIC}
                </td>
              </tr>
            </tbody>
          </table>
          <br />
        </div>
      );
    }

    if (CONFIG.REQURE_SOCIAL_LOGIN && !this.state.authorized) {
      return <Unauthorized />;
    }
    let category = <span style={{fontSize: '75%', marginLeft: '-36px'}}>{this.state.inner_category}</span>;

    let questionLines = newlineToBr(this.state.questionLines);
    let mainQuestion = <span dangerouslySetInnerHTML={questionLines}></span>;
    let answerLines = newlineToBr('');
    let answerLines2 = newlineToBr('');
    let resultAnswer = this.state.answerLines2 ? this.state.answerLines2 : '';
    if (this.state.answerLines) {
      answerLines = newlineToBr(this.state.answerLines + '\n', 'brief_answer');
      answerLines2 = newlineToBr(resultAnswer, 'answer');
    } else if (this.state.answerLines2) {
      answerLines = newlineToBr(resultAnswer, 'answer');
    }
    let guideToChatFront = newlineToBr(DESIGN.GUIDE_TO_CF, 'guide_to_chatfront');
    const datetime = this.state.datetime;
    const result = {id: this.props.params.id};
    const logId = this.state.logId;
    const logUrl = '/api/logging/shareqa/';

    return (
      <div className="container">
        <ShareNavbar />
        <table
          className="table"
          style={{
            fontSize: 'medium',
            wordBreak: 'break-all',
            marginTop: '10px'
          }}
        >
          <tbody>
            <tr className="question-text">
              <td
                style={{
                  width: '33px',
                  paddingTop: '15px',
                  paddingBottom: '15px'
                }}
              >
                <span style={{fontSize: '75%'}}> </span>
                <br />
                Q:
              </td>
              <td colSpan="2" style={{paddingTop: '15px', paddingBottom: '0px'}}>
                {category}
                <br />
                {mainQuestion}
              </td>
            </tr>
            <tr ref={(node) => (this.AnswerTr = node)}>
              <td style={{paddingTop: '15px', paddingBottom: '0px'}}>A:</td>
              <td
                style={{
                  paddingTop: '15px',
                  paddingBottom: '0px',
                  width: '150px'
                }}
              >
                {DESIGN.DEFAULT}
              </td>
              <td colSpan="2" style={{verticalAlign: 'middle'}}>
                <span dangerouslySetInnerHTML={answerLines} />
                <br />
              </td>
            </tr>
            <tr ref={(node) => (this.AnswerTr2 = node)}>
              <td></td>
              <td colSpan="2">
                <span dangerouslySetInnerHTML={answerLines2} />
              </td>
            </tr>
            <tr style={{borderBottom: '1px'}}>
              <td colSpan="3" className="text-end">
                <span className="text-muted" style={{fontSize: 'small'}}>
                  回答最終更新日 {datetime}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        {!this.state.isPreview && this.state.enableUserRating && (
          <UserRatingButton
            enableInquiry={false}
            question={this.state.questionLines}
            logUrl={logUrl}
            result={result}
            logId={logId}
            cgId={null}
            enableRatingReason={this.state.enableRatingReason}
            ratingAnswerRequired={this.state.ratingAnswerRequired}
            ratingReasonMsg={this.state.ratingReasonMsg}
            ratingReasons={this.state.ratingReasons}
          />
        )}
        <br />
        {!this.state.isPreview && <span dangerouslySetInnerHTML={guideToChatFront} />}
      </div>
    );
  }
}

ShareQAComponent.propTypes = {
  location: PropTypes.object,
  params: PropTypes.object
};

// export default ShareQA;

/*
    Class component で useParams を使うためのラッパー
    https://stackoverflow.com/questions/58548767/react-router-dom-useparams-inside-class-component
*/
function ShareQA(props) {
  return <ShareQAComponent {...props} params={useParams()} />;
}
export default ShareQA;
